import { usePage } from "PFApp/use_page";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useAccountsCollectionPage = (initPage) => {
  const { page, setPage, mergePage, resetPage } = usePage(`accounts`, initPage);

  const fetch = (page = 1, perPage = 50, term) =>
    fetchPaginatedCollection(ApiRoute(`/api/saas_admin/accounts`), {
      page: page,
      perPage: perPage,
      term: term,
      apiVersion: 1
    })
      .then((response) =>
        mergePage({
          loaded: true,
          accounts: response
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  return { ...page, fetch };
};
